import { Redirect, Route, RouteProps } from 'react-router';
import * as React from 'react';

interface PrivateRouteProps extends RouteProps {
  redirectTo?: string;
  canOpen: () => boolean;
}

export function PrivateRoute(props: PrivateRouteProps) {
  const { canOpen, redirectTo, component: Component, ...rest }: any = props;
  return (
    <Route
      {...rest}
      render={(props) =>
        canOpen() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectTo || '/session',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
